import React from "react";
import CourseLockedBottomSheet from "../CourseLockedBottomSheet/CourseLockedBottomSheet";
import { useDispatch, useSelector } from "react-redux";
import * as actionCreator from "../../store/actions";
import { getAwsAssets } from "@src/utils";
import { useTranslation } from "react-i18next";
import { initialisePaymentService } from "@src/PaymentService";

const ViewsExhaustedBottomSheet = () => {
  const { t } = useTranslation();
  const state = useSelector(
    (state) => state?.bottomSheetReducer?.showViewsExhaustedBottomSheet
  );

  const dispatch = useDispatch();
  return (
    <CourseLockedBottomSheet
      mainText={t(
        "components.bottomSheets.components.viewsExhausted.viewsExhausted",
        "Views Exhausted"
      )}
      subText={t(
        "components.bottomSheets.components.viewsExhausted.youExhaustedWatchLimit",
        "You have exhausted the watch limit set by the tutor for this video."
      )}
      btnText={t(
        "components.bottomSheets.components.viewsExhausted.buyNow",
        "Okay"
      )}
      btnAction={() => {
        dispatch(actionCreator.showViewsExhaustedBottomSheetAction(false));
        // initialisePaymentService();
      }}
      // viewAllSubText={t(
      //   "components.bottomSheets.components.viewsExhausted.goBackInstead",
      //   "Go back instead"
      // )}
      state={state}
      dispatcher={() =>
        dispatch(actionCreator.showViewsExhaustedBottomSheetAction(false))
      }
      showBtn={1}
    />
  );
};

export default ViewsExhaustedBottomSheet;
